import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  viewPieces: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
});

const Container = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.viewPieces}>{children}</div>;
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Container;
